import { render, staticRenderFns } from "./questionItem.vue?vue&type=template&id=711f47d0&scoped=true"
import script from "./questionItem.vue?vue&type=script&lang=js"
export * from "./questionItem.vue?vue&type=script&lang=js"
import style0 from "./questionItem.vue?vue&type=style&index=0&id=711f47d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711f47d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711f47d0')) {
      api.createRecord('711f47d0', component.options)
    } else {
      api.reload('711f47d0', component.options)
    }
    module.hot.accept("./questionItem.vue?vue&type=template&id=711f47d0&scoped=true", function () {
      api.rerender('711f47d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/question/questionItem.vue"
export default component.exports